import { NgModule } from '@angular/core';
import { GroupByPipe } from './shared/pipes/groupBy.pipe';
import { OrderByPipe } from './shared/pipes/oderBy.pipe';
import { DataFilterPipe } from "./shared/pipes/datafilter.pipe";
@NgModule({
    imports: [],
    declarations: [GroupByPipe, OrderByPipe, DataFilterPipe],
    exports: [GroupByPipe, OrderByPipe, DataFilterPipe],
})

export class PipeModule {
    static forRoot() {
        return {
            ngModule: PipeModule
        };
    }
}


// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./~/angular2-template-loader!./~/source-map-loader!./~/tslint-loader!./angularApp/app/PipeModule.ts